<template>

  <div>


  <v-app-bar app dark dense style="background-color: #18121E; color: #EAC67A">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <h1> EvolvED</h1>





    <v-spacer></v-spacer>

  </v-app-bar>














    <v-navigation-drawer v-model="drawer" absolute left temporary style="position: fixed; left: 0; top: 0; height: 100%; background-color: #18121E;">
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">

          <v-list-item>
            <v-img :src="require('../assets/img/temp-pics/navbar.png')">

            </v-img>
          </v-list-item>

          <v-list-item link>
            <v-list-item-content style="color: #EAC67A;">
              <div v-if="user.loggedIn">
                <v-list-item-title>{{user.data.displayName}}</v-list-item-title>
                <v-list-item-title>{{user.data.permission}}</v-list-item-title>
                <v-list-item>
                  <v-btn small class="nav-link" @click.prevent="signOut">Sign out</v-btn>
                </v-list-item>
              </div>
              <div v-else>
                <router-link to="/Login" style="text-decoration: none; color: #EAC67A;">
                  <v-btn small>Login</v-btn>
                </router-link>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <router-link to="/" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-home</v-icon>
              <span class="mr-2"> Home</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/about" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-cast-education</v-icon>
              <span class="mr-2"> About</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/pricing" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-cash</v-icon>
              <span class="mr-2"> Pricing</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/admin" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-certificate</v-icon>
              <span class="mr-2"> Admin</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/SchoolAdmin" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-certificate</v-icon>
              <span class="mr-2"> School Admin</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/Student" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-school</v-icon>
              <span class="mr-2"> Student</span>
            </router-link>
          </v-list-item>

          <v-list-item>
            <router-link to="/Student" style="text-decoration: none; color: #EAC67A;">
              <v-icon style="color: #EAC67A;">mdi-seal</v-icon>
              <span class="mr-2"> Teacher</span>
            </router-link>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>





<script>
  import { mapGetters } from "vuex"
  import firebase from "firebase"

  export default {
    props: ['person'],

    components: {
    },

    data: () => ({
      drawer: false,
      group: null,
    }),

    watch: {
        group () {
          this.drawer = false
        },
      },

      computed: {
        ...mapGetters({
    // map `this.user` to `this.$store.getters.user`
          user: "user"

        })

      },
      methods: {
        signOut() {
          firebase
            .auth()
            .signOut()
            .then(() => {
              this.$router.replace({
                name: "Home"
              });
            });
        }
      }
  };
</script>
